import type { FC } from 'react';
import { useAppStore } from '../store/useAppStore';
import { Flame, Coins } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { t } from '../i18n';

/**
 * Yuqori panel.
 *
 * Ilgari bu yerda ikkita avatar (logo + bosh harflar), "yangilash" tugmasi va
 * o'ndan ortiq inline uslub bor edi. Endi: kim ekanligingiz, qayerdaligingiz,
 * natijangiz va mavzu almashtirgichi.
 */
export const Header: FC<{ courseTitle?: string }> = ({ courseTitle }) => {
  const { studentName, role, coins, streak, centerName, coinsEnabled } =
    useAppStore();
  const isTeacher = role === 'teacher';

  const initials = isTeacher
    ? 'UST'
    : studentName
      ? studentName.trim().substring(0, 2).toUpperCase()
      : 'OQ';

  return (
    <header className="topbar">
      <div className="row" style={{ minWidth: 0 }}>
        <div className="avatar" aria-hidden="true">
          {initials}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="topbar-title">
            {isTeacher ? t('Oʻqituvchi rejimi') : studentName}
          </div>
          <div
            className="topbar-sub"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {courseTitle || centerName || 'Shaftoli'}
          </div>
        </div>
      </div>

      <div className="row" style={{ gap: 'var(--space-2)' }}>
        {!isTeacher && (
          <div
            className="row"
            style={{ gap: 'var(--space-2)' }}
            aria-label={
              coinsEnabled
                ? t('{coins} tanga, {streak} kunlik ketma-ketlik', {
                    coins,
                    streak,
                  })
                : t('{streak} kunlik ketma-ketlik', { streak })
            }
          >
            {/* Tanga moduli o'chiq bo'lsa chip ko'rsatilmaydi — hech
                narsaga sarflanmaydigan raqamni sarlavhada saqlab turish
                o'quvchini chalkashtiradi. */}
            {coinsEnabled && (
              <span className="chip chip-warning">
                <Coins size={13} aria-hidden="true" /> {coins}
              </span>
            )}
            <span className="chip chip-accent">
              <Flame size={13} aria-hidden="true" /> {streak}
            </span>
          </div>
        )}
        <ThemeToggle />
      </div>
    </header>
  );
};
